<template>
  <b-card class="mb-4" no-body>
    <template v-slot:header>
      <p class="m-0 p-0 normal-line-height">
        {{ $t(titulo) }}
        <br />
        <small>{{ $t("Total " + titulo + " por data") }}</small>
      </p>
    </template>
    <b-card-body class="p-0 area-chart">
      <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895FF"
      />
      <area-chart
        :data="data"
        :labels="[titulo]"
        :xLabelFormat="dateFormat"
        class="area-chart-graph"
        grid="true"
        grid-text-weight="bold"
        id="area-chart"
        :line-colors="[color]"
        parseTime="false"
        resize="true"
        xkey="date"
        :ykeys="[tipo]"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import Raphael from "raphael/raphael";
import { AreaChart } from "vue-morris";

global.Raphael = Raphael;

export default {
  name: "GruposGraph",
  components: {
    AreaChart,
  },
  props: {
    data: Array,
    range: {
      type: String,
      default: "weekly",
    },
    loading: {
      type: Boolean,
      default: true,
    },
    titulo: {
      type: String,
      default: "Grupos",
    },
    tipo: {
      type: String,
      default: "grupos",
    },
    color: {
      type: String,
      default: "#5895FF",
    },
  },
  methods: {
    dateFormat(d) {
      moment.locale(window.config.date_locale);
      return moment(d.label).format(
        this.range === "yearly"
          ? "MMMM"
          : this.range === "monthly"
          ? "DD, MMMM"
          : "DD, dddd"
      );
    },
  },
};
</script>
